import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyOrders } from "../../redux/thunks/orderThunks";
import "./HistoryTable.css";

const HistoryTable = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const myOrders = useSelector((state) => state.orders.myOrders);

  useEffect(() => {
    if (user?.data?.id) {
      dispatch(fetchMyOrders(user.data.id));
    }
  }, [dispatch, user?.data?.id]);

  return (
    <div className="table-responsive history-table-wrapper">
      <table className="table table-striped table-bordered bg-white text-dark">
        <thead>
          <tr>
            <th>Buy</th>
            <th>Sell</th>
            <th>Amount</th>
            <th>Rate</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {myOrders && myOrders.length > 0 ? (
            myOrders.map((order) => (
              <tr key={order.id}>
                <td>{order.secondary_currency}</td>
                <td>{order.primary_currency}</td>
                <td>{order.amount}</td>
                <td>{order.rate}</td>
                <td>{order.status}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No orders found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryTable;
